import { FlowerCareTips } from "../components/FlowerCareTips";

import "../assets/scss/components/_product-description.scss";
import type { ProductDescriptionProps } from "../types/components/ProductDescriptionProps";

export const ProductDescription = ({
	shortDescription,
	fullDescription,
	productName = "",
	id = "",
	sku = "",
	productType,
}: ProductDescriptionProps) => {
	const renderFullDescription = (description: string) => {
		return description.split("\n").map((line, index) => {
			if (line[0] === "*") {
				return (
					<span key={index} className="description-bullet-item">
						{line.substring(1).trim()}
					</span>
				);
			} else {
				return (
					<p key={index} className="description-paragraph">
						{line}
					</p>
				);
			}
		});
	};

	return (
		<section className="description-section">
			<div className="product-debug-information">{`${id} - ${sku}`}</div>

			<h1 className="product-name">{productName ?? " "}</h1>
			{shortDescription && <strong className="short-description">{shortDescription}</strong>}
			{fullDescription &&
				(fullDescription.includes("</") ? (
					<div className="description" dangerouslySetInnerHTML={{ __html: fullDescription }}></div>
				) : (
					<div className="description">{renderFullDescription(fullDescription)}</div>
				))}
			{productType === "Flowers" && <FlowerCareTips />}
		</section>
	);
};
